module.exports = __webpack_public_path__ + "static/media/onboarding-usc.4facfcd7.jpg";